import type { RouteRecordRaw } from 'vue-router'

import { ROUTES } from '~/scopes/auth/route-names'

import { CHECKOUT_BOUYGUES_IN_STORE } from './route-names'

const routes: RouteRecordRaw[] = [
  {
    path: 'checkout/in-store/bouygues-telecom/error',
    name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.ERROR,
    component: () =>
      import(
        '~/scopes/checkout/flows/bouygues-in-store/components/BouyguesMagicLinkError/BouyguesMagicLinkError.vue'
      ),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      layout: false,
    },
  },
  {
    path: 'checkout/in-store/bouygues-telecom/:magicLinkId',
    name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.SELF,
    redirect: { name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.CART },
    component: () =>
      import(
        '~/scopes/checkout/flows/bouygues-in-store/layout/BouyguesMagicLinkLayout/BouyguesMagicLinkLayout.vue'
      ),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      layout: false,
    },
    children: [
      {
        path: 'cart',
        name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.CART,
        component: () =>
          import(
            '~/scopes/checkout/flows/bouygues-in-store/pages/CartStep/CartStep.vue'
          ),
      },
      {
        path: 'address-edition',
        name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.ADDRESSES,
        component: () =>
          import(
            '~/scopes/checkout/flows/bouygues-in-store/pages/AddressesStep/AddressesStep.vue'
          ),
      },
      {
        path: 'payment',
        name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.PAYMENT,
        component: () =>
          import(
            '~/scopes/checkout/flows/bouygues-in-store/pages/PaymentStep/PaymentStep.vue'
          ),
      },
    ],
  },
  {
    path: 'checkout/in-store/bouygues-telecom/:magicLinkId/payment-result/:paymentId?',
    name: CHECKOUT_BOUYGUES_IN_STORE.BOUYGUES_TELECOM.PAYMENT_RESULT,
    component: () => import('~/scopes/checkout/pages/Result/Result.vue'),
    meta: {
      owners: ['bot-squad-checkout-front'],
      auth: {
        required: true,
        redirection: {
          name: ROUTES.AUTH.LOGIN,
          query: { bm_journey: 'bouygues_store_customer' },
        },
      },
    },
  },
]

export default routes
